export const getIsRegis = (device: {
  profile: { source?: string | null; sourceInfo?: string | null };
}) => {
  return device.profile.source === 'virtual' && device.profile.sourceInfo === 'REGIS';
};
